export const create = {
  form: {
    quantity: '投入量(ケース数）',
    submit: '新規追加',
    requireQuantity: '投入量(ケース数）を入力してください',
    invalidNumbers: '数字のみ入力できます。',
  },
  pageHeader: {
    title: '投入履歴　新規追加画面',
    back: '戻る',
  },
}
